import { useEffect } from "react"

import { providerBrowserCheck } from "@/lib/auth-utils"
import {
  selectAuthFlowEmail,
  selectAuthFlowEmailLocked,
  selectAuthFlowProviders,
} from "@/lib/storage/auth-slice"
import { initAppleSignIn, initGoogleSignIn } from "@/lib/storage/auth-thunks"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import { selectBrowser } from "@/lib/storage/user-slice"
import AppleSignInButton from "@/components/auth/apple-sign-in"
import GoogleSignInButton from "@/components/auth/google-sign-in"
import { Separator } from "@/components/ui/separator"

export function AuthProviderButtons() {
  const dispatch = useAppDispatch()
  const browser = useAppSelector(selectBrowser)
  const providers = useAppSelector(selectAuthFlowProviders)
  const emailLocked = useAppSelector(selectAuthFlowEmailLocked)
  const lockedEmail = useAppSelector(selectAuthFlowEmail)

  // If providers array is empty, show every provider (email step behavior)
  // If providers has items, only show those providers that are in the list
  const expectsGoogle =
    !providerBrowserCheck("google", browser) &&
    (providers.length === 0 || providers.includes("google"))

  const expectsApple =
    !providerBrowserCheck("apple", browser) &&
    (providers.length === 0 || providers.includes("apple"))

  // The provider SDKs are third-party scripts (accounts.google.com, appleid.cdn-apple.com)
  // that only these buttons use, so they load when the buttons first mount rather than
  // on every page boot. Both thunks are idempotent.
  useEffect(() => {
    if (expectsGoogle) void dispatch(initGoogleSignIn())
    if (expectsApple) void dispatch(initAppleSignIn())
  }, [dispatch, expectsGoogle, expectsApple])

  if (!expectsGoogle && !expectsApple) return null

  return (
    <>
      <div className="my-1 flex items-center gap-5">
        <Separator className="flex-1" />
        <span>or</span>
        <Separator className="flex-1" />
      </div>
      {emailLocked && lockedEmail && (
        <p className="text-center text-xs text-muted">
          {"Use your "}
          <span className="font-medium">{lockedEmail}</span>
          {" account"}
        </p>
      )}
      <div className="flex justify-center gap-3">
        {expectsGoogle && <GoogleSignInButton />}
        {expectsApple && <AppleSignInButton />}
      </div>
    </>
  )
}
